// extracted by mini-css-extract-plugin
module.exports = {"Details":"Alert_Details__xUsvq"};